import api from "./services/mkm.api.js"

const resource = "/fortbildung"

export default{
    alle(kuerzel) {
        return api.get(`${resource}/list/${kuerzel}`);
    },
    meta(){
        return {
            instrumente: function () {
                return api.get(`${resource}/instrumente`)
            },
            musikschulen: function(typ){
                return api.get(`${resource}/musikschulen`)
            }
        }
    },
    textbloecke(kuerzel) {
        return api.get(`${resource}/${kuerzel}/textbloecke`)
    }
}